{
  "CSB": {
    "abbreviation": "CSB",
    "short": "Centraal stembureau",
    "full": "Centraal stembureau (CSB)"
  },
  "GSB": {
    "abbreviation": "GSB",
    "short": "Gemeentelijk stembureau",
    "full": "Gemeentelijk stembureau (GSB)"
  }
}
